// extracted by mini-css-extract-plugin
export default {"slideIn":"ASPricing_slideIn__9HI6z","pageContainer":"ASPricing_pageContainer__7wCLc","h2":"ASPricing_h2__opIjJ"};